import store from '@/store';

export const unfoldError = ( msgIndex, timeout = 10000 ) => {

    store.dispatch( 'topInfoToggle', {

        type: 'error',
        msgIndex,
        timeout

    });

};

export const unfoldSuc = ( msgIndex, timeout = 5000 ) => {

    store.dispatch( 'topInfoToggle', {

        type: 'success',
        msgIndex,
        timeout

    });

};



// WEBPACK FOOTER //
// ./src/common/js/notice.js